import { Tab, TabList, Tabs } from '@podiumhq/design-system';

export const SelectPlanPriceTermSwitcher = ({
  handleTabChange,
  tabIndex,
  ...props
}) => (
  <Tabs
    display="flex"
    index={tabIndex}
    justifyContent="center"
    onChange={handleTabChange}
    variant="enclosed"
    {...props}
  >
    <TabList>
      <Tab>Monthly</Tab>
      <Tab>Yearly</Tab>
    </TabList>
  </Tabs>
);
